'use strict';

var MultiSelectComboboxSelectAllFactory = function MultiSelectComboboxSelectAllFactory() {
  var SelectAll = function SelectAll() {
    this.selected = false;
    this.dropdownVisibleValue = 'Select all';
    this.isSelectAll = true;
  };
  return SelectAll;
};
MultiSelectComboboxSelectAllFactory.$inject = [];
module.exports = MultiSelectComboboxSelectAllFactory;